import { RouteRecordRaw } from "vue-router";
import Home from "../views-m/home/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: false,
    },
  },
  {
    path: "/catalog/:id",
    name: "Catalog",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views-m/catalog/index.vue"),
  },
  {
    path: "/article",
    name: "Article",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: true,
    },
    component: () =>
      import(/* webpackChunkName: "article" */ "../views-m/article/index.vue"),
  },
  {
    path: "/search",
    name: "Search",
    meta: {
      // bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views-m/search/index.vue"),
  },
  {
    path: "/hof",
    name: "hof",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      // showBanner: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views-m/hof/index.vue"),
  },
  {
    path: "/classes/",
    name: "classes",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views-m/classes/index.vue"),
  },
  {
    path: "/races",
    name: "races ",
    meta: {
      bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
      showBanner: false,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views-m/races/index.vue"),
  },
  {
    path: "/construction",
    name: "construction",
    // meta: {
    //   bg: "https://static.web.sdo.com/mxd/pic/wiki/theme/index_bg.jpg",
    //   showBanner: true,
    // },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views-m/construction/index.vue"),
  },
];

export default routes;
